<div class="site-unavailable">
  <div *ngIf="translate.currentLang == 'ru'" inlineSVG="assets/images/errors/500.svg"></div>
  <div *ngIf="translate.currentLang != 'ru'" inlineSVG="assets/images/errors/500_kz.svg"></div>
  <div class="site-unavailable__title">{{'theSiteIsTemporarilyUnavailableDueToTechnicalProblems' | translate}}</div>
  <div class="site-unavailable-block">
    <div class="site-unavailable__text">{{'weAreWorkingToResolveThemAndApologizeForAnyInconvenienceThisMayCausePleaseTryToVisitTheSiteLater' | translate}}</div>
  </div>
</div>
